<template>
  <div class="padded" style="text-align: left;">

    <el-row v-if="!hideTop" align="bottom" :gutter="2" style="padding-bottom: 1.3em;">

      <div>
        <el-col align="middle" :span="24">

          <filter-bar

          :title="title"
          :icon="icon"

          :title-heading="titleHeading"

          :hide-org-badge="hideOrgBadge"
          :org-badge-no-full-name="orgBadgeNoFullName"
          :org-badge="orgBadge"

          :title-class="titleClass"

          :search-placeholder="searchPlaceholder"
          :show-search="showSearch"

          :comp="addAction ? addAction : null"
          :comp-props="addAction && addProps ? addProps : null"

          :bottom-comp="bottomComp"
          :bottom-comp-props="bottomCompProps"

          :show-refresh="showRefresh"
          :show-sort="isArray(sort)"

          :sort-fields="isArray(sort) ? sort : null"
          :default-filter="defaultFilter"
          :set-sort-event="sortEvent"

          :set-filter-event="filterEvent"
          :reset-filter-event="filterReset"

          :refresh-event="refreshTable"

          :table-loading="loadingEvent"
          :table-loaded="loadedEvent" />

        </el-col>

      </div>

    </el-row>




    <div v-if="isLoading && hideTop" class="pull-right"><i class="fa fa-spinner fa-spin"></i></div>

    <vuetable
        v-if="selectedSortField"
        :ref="tableRef"
        :name="this.url"

        :api-url="getEndpoint(this.url)"
        :append-params="moreParams"

        :fields="localFields"
        :css="tableCss"

        pagination-path=""
        :multi-sort="true"
        :track-by="trackBy"
         multi-sort-key="ctrl"
        :sort-order="sortOrder"
        :per-page="perPage"


        :detail-row-component="detailRow"
        :detail-row-options="options"
        :http-fetch="httpFetch"

        @expiry-item="customAlertHandler"

        @vuetable:checkbox-toggled="onCheckedItem"
        @vuetable:checkbox-toggled-all="onCheckedAll"
        @vuetable:cell-clicked="onCellClicked"

        @vuetable:pagination-data="onPaginationData"

        @vuetable:loading="showLoading"
        @vuetable:load-success="onSuccess"
        @vuetable:loade-error="onError"
        @vuetable:loaded="onLoaded"
        >
<!--         @vuetable:detail-row-clicked="onDetailRowClicked" -->


    <template v-for="fieldSlot in fieldSlots" :slot="fieldSlot" slot-scope="props">
       <slot v-if="fieldSlot !== '__show_hide_detail'" :row-data="props.rowData" :name="fieldSlot"></slot>
       <slot name="__show_hide_detail" v-else>
           <el-button :type="(isDetailOpen(props.rowData.id) ? 'primary' : 'info')" size="mini" round plain @click="onCellClicked(props.rowData)">
           <i :class="(isDetailOpen(props.rowData.id) ? 'fa fa-angle-down' : 'fa fa-angle-right')" />
         </el-button>
       </slot>
     </template>

  </vuetable>



  <el-row v-if="showPagination">
    <el-col align="right" :span="24">
      <data-table-pagination
        ref="pagination"
        @vuetable-pagination:change-page="onChangePage"></data-table-pagination>
    </el-col>
  </el-row>

</div>

</template>

<script>
import Vue from 'vue'
import VueEvents from 'vue-events'

import ArrayMixins from '@/mixins/ArrayMixins'
import DateMixins from '@/mixins/DateMixins'

import Vuetable from 'vuetable-2'
import axios from '@/lib/axiosClient'

Vue.use(Vuetable)
Vue.use(VueEvents)

import DataTablePagination from '@/components/atoms/tables/DataTablePagination'
import FilterBar from '@/components/atoms/tables/DataTableFilterBar'

export default {
  name: 'data-table',

  mixins: [ArrayMixins, DateMixins],

  components: {
    Vuetable,
    DataTablePagination,
    FilterBar
  },

  props: {

    url: {
      type: String,
      required: true
    },

    fields: {
      type: Array,
      required: true
    },

    tableRef: {
      type: String,
      default: 'vuetable'
    },

    detailComponent: {
      type: String,
      default: null
    },

    rowComponent: {
      type: Object,
      default: null
    },

    trackBy: {
      type: String,
      default: 'id'
    },

    icon: {
      type: String,
      default: null
    },

    stripe: {
      type: Boolean,
      default: true
    },

    options: {
      type: Object,
      default: null
    },

    perPage: {
      type: Number,
      default: 10
    },

    addAction: {
      type: Object
    },

    addProps: {
      type: Object
    },

    bottomComp: {
      type: Object,
      default: null
    },

    bottomCompProps: {
      type: Object,
      default: null
    },

    hideTop: {
      type: Boolean,
      default: false
    },

    hideOrgBadge: {
      type: Boolean,
      default: false
    },

    orgBadge: {
      type: Object,
      default: null
    },

    title: {
      type: String,
      default: null
    },

    titleHeading: {
      type: String,
      default: 'h5'
    },

    titleClass: {
      type: String,
      default: 'text-info'
    },

    showTitle: {
      type: Boolean,
      default: true
    },

    showSearch: {
      type: Boolean,
      default: true
    },

    orgBadgeNoFullName: {
      type: Boolean,
      default: false
    },

    showRefresh: {
      type: Boolean,
      default: true
    },

    searchPlaceholder: {
      type: String,
      default: 'Search...'
    },

    checkedCallback: {
      type: Function,
      default: null
    },

    defaultFilter: {
      type: String,
      default: null
    },

    sortField: {
      type: [String, Array],
      default: 'id'
    },

    sortDirection: {
      type: String,
      default: 'asc'
    },

    showPagination: {
      type: Boolean,
      default: true
    },

    params: {
      type: Object,
      default: () => {}
    }

  },



  computed: {

    fieldSlots: function () {
      return this.fields.filter(field => {

        if (typeof field === 'string') {
          return field.startsWith('__slot')
        }

        return field.name.startsWith('__slot')
      })
      .map(field => {
        if (typeof field === 'string') {
          return field.split(':')[1]
        }
        return field.name.split(':')[1]
      })
    },

    localFields: function () {
      return this.fields
    }

  },



  methods: {

    httpFetch (apiUrl, httpOptions) {
      return axios.get(apiUrl, httpOptions)
    },

    getTableRef () {
      return this.tableRef
    },

    getRefreshEvent () {
      return this.refreshTable
    },

    refresh () {
      this.$events.fire(this.loadingEvent)

      let table = this.$refs[this.tableRef]
      if (table) {
        if (this.detailComponent && this.openedRow.length > 0) {
          table.hideDetailRow(this.openedRow[this.openedRow.length - 1])
          this.openedRow = []
        }
        table.refresh()
      }
    },

    customAlertHandler () {

    },

    total () {
      this.$emit('totalChanged', this.page.total)
      return this.page.total
    },

    totalPages () {
      return this.page.last_page
    },


    onPaginationData (paginationData) {
      this.page = paginationData
      this.total()

      if (this.showPagination) {
        this.$refs.pagination.setPaginationData(paginationData)

        this.currentPage = (paginationData.last_page >= this.currentPage ? this.currentPage : this.currentPage - 1)
        this.$refs[this.tableRef].gotoPage(this.currentPage)
      }
    },

    onChangePage (page) {
      this.isLoading = true
      this.currentPage = page
      this.page =

      this.$refs[this.tableRef].changePage(page)

    },

    onCheckedItem (state, row) {
      if (this.checkedCallback && this.$refs[this.tableRef]) {
        this.checkedCallback(state, this.$refs[this.tableRef].selectedTo, row, 'row')
      }
    },

    onCheckedAll (state) {
      if (this.checkedCallback && this.$refs[this.tableRef]) {
        this.checkedCallback(state, this.$refs[this.tableRef].selectedTo, null, 'all')
      }
    },

    onCellClicked (data, field, event) {
      let table = this.$refs[this.tableRef]

      if (this.options && !data.options) {
        data.options = this.options
      }


      if (this.detailComponent) {
        table.toggleDetailRow(data.id)
      }

      if (table.isVisibleDetailRow(data.id)) {
        this.openedRow.push(data.id)

        if (this.openedRow.length >= 2) {

           if (this.isDetailOpen(this.openedRow[0])) {
             table.toggleDetailRow(this.openedRow[0])

             let position = this.openedRow.indexOf(this.openedRow[0])

             if (~position) {
               this.openedRow.splice(position, 1)
             }
           }
        }


      } else {

        let position = this.openedRow.indexOf(data.id)

        if (~position) {
          this.openedRow.splice(position, 1)
        }

      }

    },

    isDetailOpen (id) {
      let position = this.openedRow.indexOf(id)

      if (~position) {
        return true
      } else {
        return false
      }

    },

    onSortSet (sort) {
      this.selectedSortField = sort.sortField

      this.sortOrder[0].field = this.selectedSortField
      this.sortOrder[0].sortField = this.selectedSortField
      this.sortOrder[0].direction = sort.sortDirection

      Vue.nextTick(() => this.refresh())
    },

    onFilterSet (filterText) {
      this.moreParams = {
        'filter': filterText
//        'orgId': this.org().id,
//        'orgCategory': this.org().category
      }

      Vue.nextTick(() => this.refresh())
    },

    onFilterReset () {
      this.moreParams = {}

      Vue.nextTick(() => this.refresh())
    },

    showLoading () {
      this.isLoading = true
      this.$events.fire(this.loadingEvent)
    },

    onSuccess () {
      this.isLoading = false

      this.$events.fire(this.loadedEvent)
    },

    onError (err) {
      console.log(err)
      this.$message.error('The data could not be loaded: ' + err)
      this.isLoading = false
      this.$events.fire(this.loadedEvent)
    },

    onLoaded () {
      this.$events.fire(this.loadedEvent)

      if (!this.paramsDone) {
        var par = this.$route.params.id

        if (par) {
          this.onFilterSet(par)
        }
/*
        if (this.defaultFilter) {
          this.onFilterSet(this.defaultFilter)
        }
*/
        this.paramsDone = true
      }
    }
  },

  data () {
    return {
      showAdd: this.addAction ? true : false,
      detailRow: (this.rowComponent
        ? this.rowComponent
        : (this.detailComponent
          ? this.detailComponent
          : null)),
      isLoading: true,
      sort: this.sortField,
      filterEvent: 'filter-set',
      filterReset: 'filter-reset',
      sortEvent: 'sort-set',
      refreshTable: 'refresh-table',
      loadedEvent: 'table-loaded',
      loadingEvent: 'table-loading',
      currentPage: 1,
      page: {total: 0, current_page: 1, last_page: 0},
      paramsDone: false,
      localAddProps: this.addProps,
      moreParams: this.params ? this.params : {},
      expandSlot: {name: '__slot:__show_hide_detail'},
      showExpand: (this.detailComponent ? true : false),
      openedRow: [],
      selectedSortField: this.sortField,
      sortOrder: [
        {
          field: this.isArray(this.sortField) ? (this.sortField.length > 0 ? this.sortField[0] : 'id') : this.sortField,
          sortField: this.isArray(this.sortField) ? (this.sortField.length > 0 ? this.sortField[0] : 'id') : this.sortField,
          direction: this.sortDirection
        }
      ],

      tableCss: {
        tableClass: 'el-table',
        ascendingIcon: 'fa fa-chevron-up',
        descendingIcon: 'fa fa-chevron-down',
        sortHandleIcon: 'fa fa-bars'
      }
    }
  },

  mounted () {

    if (this.detailComponent) {
      this.showExpand = true
    }

    this.$events.listen(this.sortEvent, sortField => this.onSortSet(sortField))

    this.$events.listen(this.filterEvent, filterText => this.onFilterSet(filterText))
    this.$events.listen(this.filterReset, this.onFilterSet)
    this.$events.listen(this.refreshTable, this.refresh)

    this.$events.listen('vuetable-pagination:change-page', this.onChangePage)

    this.refresh()
  },

  created () {
/*
    if (this.org()) {

      let orgId = null
      let orgCategory = null

      if (this.org().id) {
        orgId = this.org().id
      }

      if (this.org().category) {
        orgCategory = this.org().category
      }

      if (this.moreParams && !this.moreParams.orgId && orgId) {
        this.moreParams.orgId = orgId
      }

      if (this.moreParams && !this.moreParams.orgCategory && orgCategory) {
        this.moreParams.orgCategory = orgCategory
      }

    }
*/

//    console.log('DataTable: append-params', this.moreParams)

    if (this.fields && this.detailComponent && !this.exists('name', this.expandSlot.name, this.fields)) {
      this.fields.unshift(this.expandSlot)
    }

    this.selectedSortField = this.isArray(this.sortField) ? (this.sortField.length > 0 ? this.sortField[0] : 'id') : this.sortField

    this.sortOrder.field = (this.selectedSortField ? this.selectedSortField : 'id')
    this.sortOrder.sortField = this.selectedSortField
    this.sortOrder.direction = (this.sortDirection ? this.sortDirection : this.sortOrder.direction)

    this.sortEvent = this.tableRef + '-' + this.sortEvent
    this.filterEvent = this.tableRef + '-' + this.filterEvent
    this.filterReset = this.tableRef + '-' + this.filterReset
    this.refreshTable = this.tableRef + '-' + this.refreshTable
    this.loadingEvent = this.tableRef + '-' + this.loadingEvent
    this.loadedEvent = this.tableRef + '-' + this.loadedEvent

    if (this.addAction && !this.addProps) {
      this.localAddProps = {size: 'small'}
    }

    if (this.addProps && !this.localAddProps.hasOwnProperty('size')) {
      this.localAddProps.size = 'small'
    }

  },


  beforeDestroy () {
    this.$events.remove(this.sortEvent)

    this.$events.remove(this.filterEvent)
    this.$events.remove(this.filterReset)
    this.$events.remove(this.refreshTable)
    this.$events.remove('vuetable-pagination:change-page')
  }
}
</script>



// WEBPACK FOOTER //
// DataTable.vue?285f1096